import React from "react";
import styles from "./DiscountCard.module.scss";
import discountIcon from "images/discount.svg"

export const DiscountCard: React.FC<any> = () => {
  return (
    <>
      <div className={styles.discountText}>
        <img
          className={styles.iconCircle}
          src={discountIcon}
          alt="discount"
        />{" "}
        $25 OFF Purchase - Book Now *
      </div>
    </>
  );
};
